import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {APIClient} from "../../../helpers/ApiHelper";


export const logout = createAsyncThunk(
    "logoutTest",
    async (_, { rejectWithValue }) => {
        try {
            // Use your APIClient instance
            const apiClient = new APIClient();

            const storedUser = sessionStorage.getItem("authUser");
            const userData = JSON.parse(storedUser);

            return await apiClient.create("/api/v1/auth/logout", {
                headers: {
                    Authorization: `Bearer ${userData.data.accessToken}`,
                },
            });
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);



export const logoutSlice = createSlice({
    name: "logout",
    initialState: {
        loading: false,
        isLoggedOut: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(logout.pending, (state) => {
                state.loading = true;
            })
            .addCase(logout.fulfilled, (state, action) => {
                state.loading = false;
                state.isLoggedOut = true;
            })
            .addCase(logout.rejected, (state, action) => {
                state.loading = false;
            });

    },
});

// export default veloxityDeviceSlice.reducer;
export default logoutSlice.reducer;
